import {
    Td,
    IconButton,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverArrow,
    PopoverCloseButton,
    PopoverHeader,
    PopoverBody,
    Box,
    Text,
    Avatar,
    VStack,
    HStack,
  } from "@chakra-ui/react";
  import React from "react";
 import { FiUsers as _FiUsers } from "react-icons/fi";


 const FiUsers = _FiUsers as unknown as React.ComponentType<any>;
  
  // User Interface
  interface User {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  }
  
  // Props Interface
  interface AssignedUsersPopoverProps {
    assignedUsers: string[]; // User IDs
    usersData: User[]; 
    color:string;
    bg:string;      // List of all users
  }
  
  const AssignedUsersPopover: React.FC<AssignedUsersPopoverProps> = ({
    assignedUsers,
    usersData,
    color,
    bg,
  }) => {
    // ✅ Fetch assigned user details
    const assignedUserDetails: User[] = assignedUsers
      .map((userId) => usersData.find((user) => user.id === userId))
      .filter(Boolean) as User[];
  
    return (
      <Popover placement="bottom-start">
        <PopoverTrigger>
          <IconButton
          height={"20px"}
            aria-label="View Assigned Users"
            icon={<FiUsers />}
            variant="ghost"
            color={"black"}
            _hover={{ bg: "gray.100" }}
          />
        </PopoverTrigger>
  
        <PopoverContent boxShadow="lg" borderColor="gray.300" w="250px">
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader
            fontWeight="bold"
            bg="gray.50"
            borderBottom="1px solid"
            borderColor="gray.200"
          >
            Assigned Users
          </PopoverHeader>
  
          <PopoverBody   bg="gray.50" maxHeight={"300px"} overflowY={"auto"}>
            {assignedUserDetails.length > 0 ? (
              <VStack align="start" spacing={3}>
                {assignedUserDetails.map((user) => (
                  <Box
                    key={user.id}
                    p={1}
                    w="100%"
                    _hover={{ bg: "gray.100", borderRadius: "md" }}
                  >
                    <HStack spacing={3}>
                      <Avatar
                        name={`${user.firstName} ${user.lastName}`}
                        size="sm"
                      />
                      <Box>
                        <Text textAlign={"left"} fontWeight="medium" fontSize="sm">
                          {user.firstName} {user.lastName}
                        </Text>
                        <Text fontSize="xs" color="gray.500">
                          {user.email}
                        </Text>
                      </Box>
                    </HStack>
                  </Box>
                ))}
              </VStack>
            ) : (
              <Text fontSize="sm" color="gray.500" textAlign="center">
                No users assigned.
              </Text>
            )}
          </PopoverBody>
        </PopoverContent>
      </Popover>
    );
  };
  
  export default AssignedUsersPopover;
  